export default "__VITE_ASSET__DdhNE9MO__"